import * as Safe from "safe-portals";
import { PLUGIN_NAME } from "./constants";
import { makeActionTypeDefinition } from "@flow/common/action_type";

export const social_share_action_type = makeActionTypeDefinition({
  plugin: PLUGIN_NAME,
  action_type: "social-share-action",
  supports_a_b_tests: true,
  custom_config_type: Safe.obj({
    title: Safe.str,
    personalisedTitle: Safe.optional(Safe.str),
    infoAbove: Safe.str,
    infoBelow: Safe.str, // DEPRECATED: no new instancs of this config will use this property. Last used in 2023-07-10, it can be removed a sensible stretch of time from that date
    shareTextTemplate: Safe.str,
    shareTextWhatsAppTemplate: Safe.str,
    shareTextTwitterTemplate: Safe.str,
    shareButtonText: Safe.str,
    nextButtonText: Safe.str,
    imageUrl: Safe.str,
    imageAltText: Safe.str,
    emailDefaultText: Safe.str,
    shortenedUrl: Safe.obj({
      whatsapp: Safe.str,
      whatsappOverride: Safe.optional(Safe.str),
      facebook: Safe.str,
      facebookOverride: Safe.optional(Safe.str),
      twitter: Safe.str,
      twitterOverride: Safe.optional(Safe.str),
      copy: Safe.optional(Safe.str),
    }),
  }),
  custom_config_defaults: {
    title: "",
    personalisedTitle: "",
    infoAbove: "",
    infoBelow: "", // DEPRECATED: no new instancs of this config will use this property. Last used in 2023-07-10, it can be removed a sensible stretch of time from that date
    shareTextTemplate: "",
    shareTextWhatsAppTemplate: "",
    shareTextTwitterTemplate: "",
    shareButtonText: "Share",
    nextButtonText: "Skip this step",
    imageUrl: "",
    imageAltText: "",
    emailDefaultText: "",
    shortenedUrl: {
      whatsapp: "",
      whatsappOverride: "",
      facebook: "",
      facebookOverride: "",
      twitter: "",
      twitterOverride: "",
      copy: "",
    },
  },
  custom_data_type: Safe.obj({
    title: Safe.str,
    personalisedTitle: Safe.optional(Safe.str),
    infoAbove: Safe.str,
    infoBelow: Safe.str, // DEPRECATED: no new instancs of this config will use this property. Last used in 2023-07-10, it can be removed a sensible stretch of time from that date
    shareTextTemplate: Safe.str,
    shareTextWhatsAppTemplate: Safe.str,
    shareTextTwitterTemplate: Safe.str,
    shareButtonText: Safe.str,
    nextButtonText: Safe.str,
    imageUrl: Safe.str,
    imageAltText: Safe.str,
    emailDefaultText: Safe.str,
    shortenedUrl: Safe.obj({
      whatsapp: Safe.str,
      whatsappOverride: Safe.optional(Safe.str),
      facebook: Safe.str,
      facebookOverride: Safe.optional(Safe.str),
      twitter: Safe.str,
      twitterOverride: Safe.optional(Safe.str),
      copy: Safe.optional(Safe.str),
    }),
  }),
  check_valid: (config) => {
    const errors: Record<string, string> = {};

    // Send a message config validation
    if (config.title.length === 0) {
      errors.title = "Title is required";
    }
    if (config.personalisedTitle && checkIfPersonalisedTitleContainsMergeTag(config.personalisedTitle)) {
      errors.personalisedTitle = "Error - Please check the merge tag { member_name } is formatted correctly";
    }
    if (config.shareTextTemplate.length === 0) {
      errors.shareTextTemplate = "Default sharing message is required";
    }
    if (config.nextButtonText.length === 0) {
      errors.nextButtonText = "Skip button text required";
    }

    return { valid: Object.keys(errors).length === 0, errors: errors };
  },
});

function checkIfPersonalisedTitleContainsMergeTag(personalisedTitle: string) {
  if (personalisedTitle.length > 0) {
    return !personalisedTitle.includes("{ member_name }");
  }
  return true;
}

export const SocialShareActionConfigSerializer = Safe.obj({
  title: Safe.str,
  personalisedTitle: Safe.optional(Safe.str),
  infoAbove: Safe.str,
  infoBelow: Safe.str, // DEPRECATED: no new instancs of this config will use this property. Last used in 2023-07-10. It should be removed a sensible stretch of time from that date
  shareTextTemplate: Safe.str,
  shareTextWhatsAppTemplate: Safe.str,
  shareTextTwitterTemplate: Safe.str,
  shareButtonText: Safe.str,
  nextButtonText: Safe.str,
  imageUrl: Safe.str,
  imageAltText: Safe.str,
  emailDefaultText: Safe.str,
  shortenedUrl: Safe.obj({
    whatsapp: Safe.str,
    whatsappOverride: Safe.optional(Safe.str),
    facebook: Safe.str,
    facebookOverride: Safe.optional(Safe.str),
    twitter: Safe.str,
    twitterOverride: Safe.optional(Safe.str),
    copy: Safe.optional(Safe.str),
  }),
});

export type SocialShareActionConfig = Safe.TypeIn<typeof SocialShareActionConfigSerializer>;
